import { ASSIGNED_DIFFICULTIES } from '@all-for-one/shared-types'
import { memo } from 'react'

/**
 * @module lesson-builder/components/difficulty-row
 * @description The difficulty-tab selector on a question slide. Replaces
 * the dead components/difficulty-row.js deleted 2026-09-30 (zero real
 * importers at the time) -- that file's concept was right, its content
 * had just drifted from the real, live version that stayed inline in
 * question-slide.tsx. This extraction promotes the current, correct
 * version instead of re-creating the stale one. See
 * docs/BLUEPRINT-2026-10-01-question-slide-decomposition.md.
 */

// Each tier gets its own active color (mockup's tier-tabs pattern) rather
// than one generic "active" state, matching the level control on the
// classroom roster.
const DIFFICULTY_ACTIVE_CLASS: Record<string, string> = {
	[ASSIGNED_DIFFICULTIES.EMERGING]: 'active-emerging',
	[ASSIGNED_DIFFICULTIES.INTERMEDIATE]: 'active-intermediate',
	[ASSIGNED_DIFFICULTIES.ADVANCED]: 'active-advanced',
}

export const DifficultyRow = memo(({ currentDifficulty, handleDifficultyChange }: { currentDifficulty: string, handleDifficultyChange: (difficulty: string) => void }) => {
	return (<div className="difficulty-row">
		<div className="difficulty-row-inner" role="tablist" aria-label="Filter questions by level">
			{Object.values(ASSIGNED_DIFFICULTIES).map((difficulty: string) => (
				<button
					key={difficulty}
					type="button"
					role="tab"
					aria-selected={currentDifficulty === difficulty}
					className={`difficulty-tab ${currentDifficulty === difficulty ? DIFFICULTY_ACTIVE_CLASS[difficulty] : ''}`}
					onClick={() => handleDifficultyChange(difficulty)}
				>
					{difficulty}
				</button>
			))}
		</div>
	</div>)
})

export default DifficultyRow
